import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { PatientRoutingModule } from './patient-routing.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProfileComponent } from './pages/profile/profile.component';
import { PatientScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { PatientScheduleComponent } from './pages/schedule/schedule.component';
import { PatientScheduleDetailsComponent } from './pages/schedule/status/details/schedule-details.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { PatientScheduleEditStatusComponent } from './pages/schedule/status/edit-status/schedule-edit-status.component';
import { ScheduleProcedurePatientComponent } from './pages/schedule/procedure/schedule-procedure.component';
import { ScheduleAppointmentPatientComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { PatientScheduleRegistrationComponent } from './pages/schedule/registration/schedule-registration.component';
import { PatientMapComponent } from './components/map/map.component';
import { MatSliderModule } from '@angular/material/slider';
import { PaymentEncounterComponent } from './pages/schedule/status/payment-encounter/payment-encounter.component';
import { PaymentCreditCardComponent } from './pages/schedule/status/payment-encounter/payment-credit-card/payment-credit-card.component';
import { PaymentPixComponent } from './pages/schedule/status/payment-encounter/payment-pix/payment-pix.component';
import { PaymentPhysicalComponent } from './pages/schedule/status/payment-encounter/payment-physical/payment-physical.component';
import { QRCodeModule } from 'angularx-qrcode';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProcedureBySpecialistComponent } from './pages/schedule/procedure-by-specialist/procedure-by-specialist.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    ProfileComponent,
    PatientScheduleStatusComponent,
    PatientScheduleComponent,
    PatientScheduleDetailsComponent,
    PatientScheduleEditStatusComponent,
    ScheduleProcedurePatientComponent,
    ScheduleAppointmentPatientComponent,
    PatientScheduleRegistrationComponent,
    PatientMapComponent,
    PaymentEncounterComponent,
    PaymentCreditCardComponent,
    PaymentPixComponent,
    PaymentPhysicalComponent,
    ProcedureBySpecialistComponent,

    //shared
    //BarChartComponent,
  ],
  exports: [PatientScheduleDetailsComponent, PatientScheduleEditStatusComponent, PatientScheduleRegistrationComponent, PaymentEncounterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    PatientRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatIconModule,
    MatChipsModule,
    MatSelectModule,
    MatToolbarModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatDialogModule,
    MatSliderModule,
    QRCodeModule,
    MatIconModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
  ],
})
export class PatientModule {}
